import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';

interface DayValue {
  name: string;
  isWeekend: boolean;
}

const DAY_NAMES = {
  1: 'MON', 2: 'TUE', 3: 'WED', 4: 'THU', 5: 'FRI', 6: 'SAT', 7: 'SUN'
};

@Component({
  selector: 'app-day-range-display',
  template: `
    <!-- @formatter:off-->
    <div *ngIf="values" [class]="styleClass">
      <ng-container *ngIf="consecutive; else nonConsecutive">
        <span [ngClass]="values[0].isWeekend ? 'text-red-500' : 'text-primary'">{{ values[0]?.name }}</span>
        -
        <span [ngClass]="values[0].isWeekend ? 'text-red-500' : 'text-primary'">{{ values[1]?.name }}</span>
      </ng-container>
      <ng-template #nonConsecutive>
        <span *ngFor="let day of values; let isLast = last">
<!--          {{ day.name }}<span *ngIf="!isLast">, </span>-->
          <span [ngClass]="values[0].isWeekend ? 'text-red-500' : 'text-primary'">{{ day.name }}</span>
        </span>
      </ng-template>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DayRangeDisplayComponent implements OnChanges {
  @Input() days: number[] = [];
  @Input() styleClass = 'text-sm';

  values: DayValue[];
  consecutive: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.days) {
      const rangeValue = this.getRangeValue(changes.days.currentValue);
      this.values = rangeValue.values;
      this.consecutive = rangeValue.consecutive;
    }
  }

  private getRangeValue(days: number[]): {
    consecutive: boolean,
    values: DayValue[]
  } {
    if (!days || days.length === 0) {
      return {
        consecutive: false,
        values: []
      };
    }

    if (days.length === 1) {
      // return days.map( d => this.getDayValue(d));
      return {
        consecutive: false,
        values: [this.getDayValue(days[0])]
      };
    }

    const sortedDays = [...days].sort();
    // Check if days are consecutive
    const isConsecutive = sortedDays.every((day, index) =>
      index === 0 || day === sortedDays[index - 1] + 1
    );

    if (isConsecutive) {
      return {
        consecutive: true,
        values: [
          this.getDayValue(sortedDays[0]),
          this.getDayValue(sortedDays[sortedDays.length - 1])
        ]
      };
    } else {
      return {
        consecutive: false,
        values: sortedDays.map(day => this.getDayValue(day))
      };
    }
  }

  private getDayValue(day: number): DayValue {
    return {
      name: DAY_NAMES[day],
      isWeekend: day === 6 || day === 7 // Saturday or Sunday
    };
  }
}
